export default __webpack_public_path__ + "static/logo-7deaf8ed2842248b1b79994ba04504e7.png";